import { Component } from '@lisergia/core'
import { Viewport } from '@lisergia/managers'

import GSAP from 'gsap'

export default class extends Component {
  declare element: HTMLDivElement

  declare elements: {
    media: HTMLDivElement
    description: HTMLDivElement
  }

  constructor({ element }: { element: HTMLElement }) {
    super({
      element,
      elements: {
        media: '.foundation__item__media',
        description: '.foundation__item__description',
      },
    })

    this.onLeave()
  }

  onEnter() {
    if (Viewport.isPhone) return

    GSAP.to(this.elements.media, {
      duration: 1,
      ease: 'elastic(1, 0.75)',
      scale: 1.25,
    })

    GSAP.to(this.elements.description, {
      autoAlpha: 1,
      duration: 1,
      ease: 'elastic(1, 0.75)',
      scale: 1,
      y: 0,
    })
  }

  onLeave() {
    if (Viewport.isPhone) return

    GSAP.to(this.elements.media, {
      duration: 1,
      ease: 'elastic(1, 0.75)',
      scale: 1.05,
    })

    GSAP.to(this.elements.description, {
      autoAlpha: 0,
      duration: 1,
      ease: 'elastic(1, 0.75)',
      scale: 0.9,
      y: '50%',
    })
  }

  addEventListeners() {
    this.element.addEventListener('mouseenter', this.onEnter)
    this.element.addEventListener('mouseleave', this.onLeave)
  }

  removeEventListeners() {
    this.element.removeEventListener('mouseenter', this.onEnter)
    this.element.removeEventListener('mouseleave', this.onLeave)
  }
}
